import React, { useState, useEffect, useRef } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import Button from './Button';

const TimelineTabSlider = ({ tab, onNext, onPrev, isFirst, isLast }) => {
    const [show, setShow] = useState(false);
    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        fade: true,          // ✅ enables fade effect
        cssEase: "linear"
    };

    const videoRef = useRef(null);
    const [play, setPlay] = useState(false);

    const playVideo = () => {
        setPlay(true);
    }

    const pauseVideo = () => {
        setPlay(false);
    }

    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [hovering, setHovering] = useState(false);

    const mouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();

        setPosition({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        });
    };

    return (
        <div className='slider_wrapper'>

            <div className='row'>
                <div className='col-lg-6 video-col'>
                    {tab?.Bild_oder_Video === "Video" ? (
                        <div className={`video_thumbnail position-relative ${hovering && play ? 'hide_cursor' : ''}`} onMouseEnter={() => setHovering(true)} onMouseLeave={() => setHovering(false)} onMouseMove={mouseMove}>

                            {play && <video
                                ref={videoRef}
                                className="w-100 d-block pb-0"
                                // controls
                                autoPlay
                                playsInline
                                preload="metadata"
                                onClick={pauseVideo}
                                onEnded={pauseVideo}
                            >
                                <source
                                    src={`https://backend.bgzurlinden.ch${tab?.Video?.url}`}
                                    type="video/mp4"
                                />
                            </video>}

                            {hovering && play && (
                                <div
                                    className="video_image_cursor"
                                    style={{
                                        left: `${position.x}px`,
                                        top: `${position.y}px`,
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
                                        <path d="M120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60Z" fill={`var(--pink)`} fill-opacity="1" />
                                        <rect x="47" y="38" width="8" height="45" fill="white" />
                                        <rect x="66" y="38" width="8" height="45" fill="white" />
                                    </svg>
                                </div>
                            )}

                            {!play && (
                                <>
                                    <img
                                        src={`https://backend.bgzurlinden.ch${tab?.Videominiatur?.url}`}
                                        alt=''
                                        className='video_overlay_img'
                                    />

                                    <button
                                        type='button'
                                        onClick={playVideo}
                                        className='video_play_btn'
                                    >
                                        <svg className='icon_play' xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
                                            <circle cx="60" cy="60" r="60" fill={`var(--pink)`} />
                                            <path d="M83 60L43 83L43 37L83 60Z" fill="white" />
                                        </svg>
                                    </button>
                                </>
                            )}

                        </div>
                    ) : (
                        <div className='video_thumbnail position-relative'>
                            <img src={`https://backend.bgzurlinden.ch${tab?.Bild[0]?.url}`} alt='#' />
                        </div>
                    )}

                </div>
                <div className='col-lg-6 content-col align-self-center mt-4 mt-lg-0'>
                    <h3 className="text-pink fs_40 fw-550">{tab?.Sub_Titel}</h3>
                    <h2 className='fw-550 text-black'>{tab?.Titel}</h2>

                    {tab?.Text && <BlocksRenderer content={tab?.Text} />}

                    {tab?.Komponente && <Button component={tab?.Komponente} pdf={tab?.PDF} buttons={tab?.Button} />}

                    {/* Navigation Buttons */}
                    <div className="tab-change-button d-flex gap-3 mt-4">
                        <button className="nav_btns_custom button_prev" onClick={onPrev} disabled={isFirst}><img src="images/white-arrow-prev.svg" /></button>
                        <button className="nav_btns_custom button_next" onClick={onNext} disabled={isLast}><img src="images/white-arrow-next.svg" /></button>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default TimelineTabSlider